import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Checkbox,
  Code,
  Flex,
  Group,
  Input,
  List,
  Menu,
  rem,
  Select,
  Text,
  Textarea,
  ThemeIcon,
  Tooltip,
} from "@mantine/core";
import {
  DatePicker,
  DatePickerInput,
  DatesProvider,
  DateTimePicker,
} from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import {
  IconAdjustments,
  IconCaretDown,
  IconCircleCheck,
  IconCircleDashed,
  IconEdit,
  IconFileExport,
  IconInfoCircle,
  IconPlus,
  IconRefresh,
  IconSearch,
  IconStatusChange,
  IconTable,
  IconTimeDuration15,
  IconTrash,
  IconUpload,
  IconWash,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import {
  AllCommunityModule,
  CellSelectionChangedEvent,
  DefaultMenuItem,
  GetContextMenuItemsParams,
  INumberCellEditorParams,
  RowSelectionOptions,
  StatusPanelDef,
  ValueFormatterParams,
} from "ag-grid-community";
import { AG_GRID_LOCALE_VN } from "@ag-grid-community/locale";
import type { CustomCellRendererProps } from "ag-grid-react";
import { AgGridReact } from "ag-grid-react";
import {
  AdvancedFilterModule,
  ClientSideRowModelModule,
  ClipboardModule,
  ColDef,
  ColGroupDef,
  ColumnsToolPanelModule,
  ExcelExportModule,
  FiltersToolPanelModule,
  GetRowIdParams,
  GridChartsModule,
  GridReadyEvent,
  IServerSideDatasource,
  IServerSideGetRowsRequest,
  MasterDetailModule,
  MenuItemDef,
  MenuModule,
  ModuleRegistry,
  MultiFilterModule,
  RangeSelectionModule,
  RichSelectModule,
  RowClassParams,
  RowGroupingModule,
  RowStyle,
  ServerSideRowModelModule,
  SetFilterModule,
  SparklinesModule,
  StatusBarModule,
} from "ag-grid-enterprise";
import { modals } from "@mantine/modals";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import {
  baseTheme,
  paginationPageSize,
  paginationPageSizeSelector,
  repositoryLog,
  repositoryMdm,
  styleTableMantine,
} from "../../_base/_const/_constVar";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import { MessageResponse } from "../../model/MessageResponse";
import { formatDateTransfer } from "../../common/FormatDate/FormatDate";
import { _localization } from "../../config/location";
import { addHours, startOfDay } from "date-fns";

ModuleRegistry.registerModules([ClientSideRowModelModule, AllCommunityModule]);

type dataSubmit = {
  key: string;
  dateTimes: Array<Date>;
};

export interface SerilogLog {
  id: string;
  timestamp: Date;
  level: string;
  message_template: string;
  rendered_message: string;
  properties: string;
  computer: string;
  app: string;
  createdAt: Date;
}
export interface LoggingSearchV2Model {
  fromDate?: Date; // DateTime? -> string (ISO format)
  toDate?: Date; // DateTime? -> string (ISO format)
  level?: string;
  messT?: string;
  rend?: string;
  pro?: string;
  app?: string;
  page: number;
  isRaw: boolean;
}

const CheckDataClickHouseLogView = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<SerilogLog[]>([]);
  const [height, setHeight] = useState(0);
  const [value, setValue] = useState<Date>();
  const inputRef = useRef<string>("");
  const inputmesRef = useRef<string>("");
  const inputappRef = useRef<string>("");
  const inputproRef = useRef<string>("");
  const inputdesRef = useRef<string>("");
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 25,
  });
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const form = useForm<LoggingSearchV2Model>({
    mode: "controlled",
    initialValues: {
      page: 1,
      fromDate: addHours(startOfDay(new Date()), 1),
      toDate: addHours(startOfDay(new Date()), 23),
      rend: "HttpGlobalExceptionFilter",
      isRaw: false,
    },
  });

  useEffect(() => {
    fetchData();
  }, [pagination]);
  //Call api danh sách thiếu sót đơn đồng bộ
  const fetchData = async () => {
    try {
      let _da = {
        ...form.getValues(),
        page: pagination.pageIndex + 1,
      };
      if (_da.fromDate) _da.fromDate = addHours(_da.fromDate, 7);
      if (_da.toDate) _da.toDate = addHours(_da.toDate, 7);
      const response = await repositoryLog.post<MessageResponse<SerilogLog[]>>(
        "/api/v1/logging/get-list-log-click-house",
        _da
      );
      if (response && response.success) {
        setRowData(response.data);
        setRowCount(response.totalCount);
      } else {
        setData([]);
      }
    } catch (error) {
      // NotificationExtension.Fails("Không tìm thấy dữ liệu");
      setRowData([]);
      console.log("error", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // console.log("selectIds", selectIds);
  // console.log("data", data);
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (250 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  const [rowData, setRowData] = useState<SerilogLog[]>([]);
  const columns = React.useMemo<MRT_ColumnDef<SerilogLog>[]>(
    () => [
      {
        accessorKey: "timestamp",
        header: "Ngày giờ",
      },
      {
        accessorKey: "app",
        header: "App",
        size: 150,
      },
      {
        accessorKey: "level",
        header: "Mức độ Log",
        size: 150,
      },
      {
        accessorKey: "rendered_message",
        header: "Nội dung",
        size: 500,
        Cell: ({ renderedCellValue }: any) => (
          <>
            {" "}
            {renderedCellValue && (
              <ActionIcon
                variant="outline"
                aria-label="Settings"
                mr={"xs"}
                onClick={() => {
                  modals.openConfirmModal({
                    title: "Chi tiết ",
                    children: (
                      <Textarea value={renderedCellValue} autosize minRows={2}>
                        {" "}
                      </Textarea>
                    ),
                    size: "80%",
                    confirmProps: { display: "none" },
                    cancelProps: { display: "none" },
                  });
                }}
              >
                <IconInfoCircle
                  style={{ width: "70%", height: "70%" }}
                  stroke={1.5}
                />
              </ActionIcon>
            )}
            {renderedCellValue?.slice(0, 150)}
          </>
        ),
      },
      {
        accessorKey: "properties",
        header: "Thuộc tính",
        size: 500,
        Cell: ({ renderedCellValue }: any) => (
          <>
            {" "}
            {renderedCellValue && (
              <ActionIcon
                variant="outline"
                aria-label="Settings"
                mr={"xs"}
                onClick={() => {
                  modals.openConfirmModal({
                    title: "Chi tiết ",
                    children: (
                      <Textarea value={renderedCellValue} autosize minRows={2}>
                        {" "}
                      </Textarea>
                    ),
                    size: "80%",
                    confirmProps: { display: "none" },
                    cancelProps: { display: "none" },
                  });
                }}
              >
                <IconInfoCircle
                  style={{ width: "70%", height: "70%" }}
                  stroke={1.5}
                />
              </ActionIcon>
            )}
            {renderedCellValue?.slice(0, 150)}
          </>
        ),
      },
    ],
    [rowData]
  );

  const table = useMantineReactTable<SerilogLog>({
    columns,
    data: rowData,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["soYc", "mrt-row-select"],
        right: ["totalAmount", "actions"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    mantineTableProps: {
      striped: false,
    },
    enableSorting: false,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25"],
    },
    paginationDisplayMode: "pages",
  });

  const codeForPreviousDemo = `
  Chi tiết bảng ghi log
  id UUID DEFAULT generateUUIDv4(), 
  timestamp DateTime64(3) CODEC(Delta(8), ZSTD(1)), 
  level String CODEC(ZSTD(1)),
  message_template String CODEC(ZSTD(1)), 
  rendered_message String CODEC(ZSTD(1)), 
  properties String, 
  computer String CODEC(ZSTD(1)),
  created_at DateTime DEFAULT now() CODEC(Delta(4), ZSTD(1)), 
  app String
`;

  return (
    <>
      <_breadcrumb></_breadcrumb>
      <Code block>{codeForPreviousDemo}</Code>
      <Flex
        direction={"row"}
        mt={10}
        justify={"space-between"}
        align={"center"}
      >
        <form
          onSubmit={form.onSubmit(async (e) => {
            // await fetchData(e);
          })}
        >
          {/* <LoadingOverlay
              visible={visible}
              zIndex={1000}
              overlayProps={{ radius: "sm", blur: 2 }}
            /> */}
          <Flex direction={"row"} align={"center"} gap={"md"} wrap="wrap">
            {/* <Input
              size="sm"
              w={200}
              placeholder="Từ khóa"
              onChange={(e) => {
                inputRef.current = e.target.value;
              }}
              leftSection={<IconSearch color="#15aabf" />}
            /> */}
            <Checkbox
              size="sm"
              w={100}
              label="Query raw"
              placeholder="Message"
              defaultValue={form.getValues().isRaw ?? false}
              defaultChecked={form.getValues().isRaw ?? false}
              {...form.getInputProps("isRaw", {
                type: "checkbox",
              })}
            />
            <Input
              size="sm"
              w={500}
              placeholder="Nội dung"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("rend")}
            />
            <Input
              size="sm"
              w={200}
              placeholder="Application name"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("app")}
            />
            <Input
              size="sm"
              w={200}
              placeholder="Thuộc tính"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("pro")}
            />
            <DatesProvider settings={{ timezone: "Asia/Ho_Chi_Minh" }}>
              <DateTimePicker
                clearable
                key={form.key("fromDate")}
                {...form.getInputProps("fromDate")}
              />
            </DatesProvider>
            <DatesProvider settings={{ timezone: "Asia/Ho_Chi_Minh" }}>
              <DateTimePicker
                clearable
                key={form.key("toDate")}
                {...form.getInputProps("toDate")}
              />
            </DatesProvider>

            <Button
              type="submit"
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Flex>
        </form>
      </Flex>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default CheckDataClickHouseLogView;
